import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { profileSelectors } from '@ucheba/store/profile'
import { IProgramId } from '@ucheba/store/institutions/programs/programId/types'

interface IUseProgramExams {
  (
    requiredSubjects: IProgramId['requiredExams'],
    optionalSubjects: IProgramId['optionalExams']
  ): {
    requiredExams: {
      examId: number
      name: string
    }[]
    optionalExams: {
      examId: number
      name: string
    }[]
    selectedExams: {
      examId: number
      score: number | null
    }[]
  }
}

export const useProgramExams: IUseProgramExams = (requiredSubjects, optionalSubjects) => {
  const profile = useSelector(profileSelectors.entity)
  const dispatch = useDispatch()

  const requiredExams = useMemo(() => {
    if (requiredSubjects) {
      return requiredSubjects.map((exam) => {
        return {
          examId: exam.exam.id,
          name: exam.exam.subject?.name || exam.exam.name,
        }
      })
    }

    return []
  }, [requiredSubjects])

  const optionalExams = useMemo(() => {
    if (optionalSubjects) {
      return optionalSubjects.map((exam) => {
        return {
          examId: exam.exam.id,
          name: exam.exam.subject?.name || exam.exam.name,
        }
      })
    }

    return []
  }, [optionalSubjects])

  const selectedExams = useMemo(() => {
    if (profile?.enrolleeInfo?.exams) {
      return profile?.enrolleeInfo?.exams.map((exam) => {
        return {
          examId: exam.exam.id,
          score: exam.score,
        }
      })
    }

    return []
  }, [profile, dispatch])

  return {
    requiredExams,
    optionalExams,
    selectedExams,
  }
}
